import React from "react";
import { Button, Flex, List, Spinner } from "@ebscois/react-component-library";
import { StyledLabel, StyledList, StyledFullTextDiv } from "./_.styled";
import useFtLinks from "../../hooks/useFtLinks";
import { DOI_LINK } from "../../constants/doi-urls";

export const FullTextLinks = ({
  docId,
  docType,
  additionalFtLinks,
  telemetryData,
}) => {
  const { targetLinks, isFetching, apiError, errorMessage } = useFtLinks(
    docId,
    docType,
    telemetryData
  ).ftLinks;

  if (apiError) {
    // Logging Full Text Link API error with docId
    window?.DD_RUM?.addError(
      new Error(
        `Full Text Link API error for docId: ${docId} with error message: ${errorMessage}`
      ),
      {
        scope: "platform-content",
        team: "cd.mergeconflict",
      }
    );
  }

  return (
    <StyledFullTextDiv data-testid="ftlink-dialog">
      {isFetching ? (
        <Spinner size="md" data-testid="loading-spinner" />
      ) : (
        <>
          <StyledLabel element="h5" data-testid="fullText-category">
            Full Text/Abstract:
          </StyledLabel>
          <Flex container justify={{ content: "space-between" }}>
            <StyledList>
              {targetLinks &&
                targetLinks.map((link) => (
                  <List.Item data-testid="fullText-abstract-link">
                    <Button kind="anchor" href={link.targetUrl} target="_blank">
                      {link.linkName}
                    </Button>
                  </List.Item>
                ))}
              {docType === "doi" && (
                <List.Item>
                  <Button
                    data-testid="publisher-doi-link"
                    kind="anchor"
                    href={`${DOI_LINK}${docId}`}
                    target="_blank"
                  >
                    Original Publisher
                  </Button>
                </List.Item>
              )}
              {additionalFtLinks?.length &&
                additionalFtLinks.map((link) => (
                  <List.Item data-testid="additional-fulltext-link">
                    <Button kind="anchor" href={link.targetUrl} target="_blank">
                      {link.linkName}
                    </Button>
                  </List.Item>
                ))}
            </StyledList>
          </Flex>
        </>
      )}
    </StyledFullTextDiv>
  );
};

export default FullTextLinks;
